import {
  SanityArticle,
  SanityBlogArticle,
  SanityNewsArticle,
  SanityPlatformUpdateArticle,
  SanityTag
} from "../../types/graphql-types";

export function getNumberOfMatchingTags(
  currentTags?: SanityTag[],
  possibleRelatedTags?: SanityTag[]
): number {
  let numberOfMatchingTags = 0;

  if (!currentTags || !possibleRelatedTags) {
    return numberOfMatchingTags;
  }

  possibleRelatedTags.forEach(tag => {
    if (currentTags.some(currentTag => currentTag._id === tag._id)) {
      numberOfMatchingTags = numberOfMatchingTags + 1;
    }
  });

  return numberOfMatchingTags;
}

export function filterRelatedArticles<
  T extends
    | SanityArticle
    | SanityBlogArticle
    | SanityNewsArticle
    | SanityPlatformUpdateArticle
>(article: T, possibleRelatedArticles: T[], maxTake: number = 3): T[] {
  const articleTags: SanityTag[] = article.tags?.map(tag => tag as SanityTag) ?? [];

  const articles = possibleRelatedArticles
    ?.filter(
      relatedArticle =>
        relatedArticle._id !== article._id &&
        relatedArticle.tags &&
        relatedArticle.tags.length > 0 &&
        relatedArticle.language?.toLowerCase() === article.language?.toLowerCase() &&
        getNumberOfMatchingTags(
          articleTags,
          relatedArticle.tags.map(tag => tag as SanityTag) ?? []
        ) > 0
    )
    .sort((a, b) =>
      getNumberOfMatchingTags(articleTags, a.tags?.map(tag => tag as SanityTag) ?? []) >
      getNumberOfMatchingTags(articleTags, b.tags?.map(tag => tag as SanityTag) ?? [])
        ? -1
        : 1
    )
    .slice(0, maxTake);

  return articles;
}
